<template>
  <span v-html="dynamicValue"></span>
</template>

<script>
import { styleLog } from "../../../utils/style-log";
import moment from "moment";
export default {
  props: {
    answerCache: {
      type: Object,
    },

    value: {
      type: String,
    },

    sample: {
      default: () => ({}),
    },
  },

  computed: {
    dynamicValue() {
      const dateFormat = (datetime, format) => {
        return moment(datetime).format(format);
      };
      const { answerCache, value, sample } = this;
      let _transormedValue = value;
      const reg = /{[\s\S]*?}/g;
      const matchRes = _transormedValue.match(reg);
      let slot;
      if (matchRes) slot = matchRes.pop();
      while (slot) {
        const graph = slot.replace(/{([\s\S]*?)}/, "$1");
        try {
          let v = `${eval(graph)}` || "";
          if (v.indexOf("未找到") > -1) {
            v = `<span class="questionnaire-label-slot-empty">${v}</span>`;
          }
          if (v.indexOf("Invalid date") > -1) {
            v = `<span class="questionnaire-label-slot-empty">${v}</span>`;
          }
          if (v === undefined) throw Error();
          _transormedValue = _transormedValue.replace(slot, v);
        } catch (err) {
          console.log(`err to replace ${slot}`, err);
          styleLog.dangerPrefix(`err to replace ${slot}`, "DynamicLabel");
          _transormedValue = _transormedValue.replace(
            slot,
            `<span class="text-grey">解析出现未知错误</span>`
          );
        }
        slot = matchRes.pop();
      }
      return _transormedValue;
    },
  },

  watch: {
    dynamicValue: {
      immediate: true,
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.$emit("update-value", this.$el.innerText);
        });
      },
    },
  },
};
</script>

<style lang="scss">
.questionnaire-label-slot-empty {
  color: grey !important;
}
</style>
